export default __webpack_public_path__ + "static/media/video-catalog.71ae30b1.svg";